import React, { useCallback } from 'react';
import { useI18n } from '../../../../../../data/hooks/i18nHooks';
import { useFilteredParticipants } from '../../../../../../data/hooks/participant/useFilteredParticipants';
import { dialogAlert } from '../../../../../elements/Dialog/dialogs';
import StartNetworkingStep from '../../../StartNetworkingStep/StartNetworkingStep';

function StepUseFavorites(props) {
    const { eventId } = props,
        i18n = useI18n(),
        [favoriteParticipants] = useFilteredParticipants(eventId, {
            favorites: true,
        });

    const handleClick = useCallback(async () => {
        await dialogAlert(i18n['start.use_favorites.info'], i18n['start.use_favorites'], i18n['label.ok']);
    }, []);

    return (
        <StartNetworkingStep href={['/events', eventId, 'participants'].join('/')} visible={true} onClick={handleClick} complete={favoriteParticipants.length > 0}>
            {i18n['start.use_favorites']}
        </StartNetworkingStep>
    );
}

export default StepUseFavorites;
